import React,{useState,useEffect,useRef} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';


function AnswerField_Multiple(props){
   
    let answers = props.answers
   
    
    var scoreIndex;
    if(props.data!=null){
        scoreIndex =getAnswerIndex(answers,props.data)
    }
    
    
    const [changed,triggerChange] = useState(props.data!=null?true:false)
    const [previous,setPrevious] = useState(props.data!=null?answers[scoreIndex][1]:0)
    const [value,setVal] = useState(props.data!=null?props.data:answers[0][0])
    const [textValue,setTextValue] = useState('')
    const handleAnswer =  (e) =>{
        setVal(e.target.value)
        const newScore = parseInt(answers[e.target.selectedIndex][1])
        if (isNaN(newScore)){
            // blank option selected — undo previous score and reset
            if (changed && !isNaN(previous)){
                props.score(-previous)
            }
            setPrevious(0)
            triggerChange(false)
        }
        else if (changed){
             props.score(-previous)
             props.score(newScore)
             setPrevious(newScore)
        }
        else{
             setPrevious(newScore)
             triggerChange(true)
             props.score(newScore)
         }
         props.handler(e)
     }
    const event_name = props.name.toString()
   
        return(
            
            <Form.Group as={Col}>
               <Form.Label>{props.title}</Form.Label>
            <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value}disabled={props.disabled} >
                    
                    {answers.map((answer,index) =>(
                        <option key={index} score={answer[1]}>{answer[0]}</option>))}
            </Form.Control>
    </Form.Group>
    
        )
    }
function Checkbox_3 (props){
    let answers = props.answers
   
    const [value,setVal] = useState(answers[0])
    const [value2,setVal2] = useState(answers[1])
    const [value3,setVal3] = useState(answers[2])
    const [check1,setCheck1] = useState((props.data!=null && props.data=='Patient')?true: false )
    const [check2,setCheck2] = useState((props.data!=null && props.data=='Caregiver')?true: false )
    const [check3,setCheck3] = useState((props.data!=null && props.data=="Patient and Caregiver in Equal Proportion")?true: false )
    const event_name = props.name
    const hanldeCheck1 =  (event) =>{
         props.handler(event)
        setCheck1(event.target.checked)
        if(event.target.checked){
        setCheck2(!event.target.checked)
        setCheck3(!event.target.checked)
        }
        
    }
    const hanldeCheck2 = (event) =>{
        props.handler(event)
         setCheck2(event.target.checked)
         if(event.target.checked){
        setCheck1(!event.target.checked)
        setCheck3(!event.target.checked)
         }
      
    }
    const hanldeCheck3 =   (event) =>{
        props.handler(event)
        setCheck3(event.target.checked)
        if(event.target.checked){
            setCheck2(!event.target.checked)
            setCheck1(!event.target.checked)
        }
        
    }
    return(
        <Form.Group as={Col}>
                <Form.Check label={answers[0]}  name={event_name} value={value} checked={check1} onChange={hanldeCheck1} disabled={props.disabled}/>
                <Form.Check label={answers[1]}  name={event_name} value={value2} checked={check2} onChange={hanldeCheck2}disabled={props.disabled}/>
                <Form.Check label={answers[2]}  name={event_name} value={value3} checked={check3} onChange={hanldeCheck3}disabled={props.disabled}/>
        </Form.Group>
    )
}
function Text_Box(props){
    const [value,setVal] = useState(props.value!=null?props.value[props.name]:'')
    const [disabled, setDisabled] = useState(true)
    
    const onChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    
    return(
        <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control type="text" onChange={onChange} name={props.name} value={value} disabled={props.disabled}/>
        </Form.Group>
    )
}

function Text_box_P4(props){ // for part 4 detect the 2 inputs and calculate the percentage
    const textbox_title = props.questions.textbox;
    const textbox_name = props.questions.textbox_name;

    const [value1,setVal1] = useState(props.data!=null?props.data[props.qname+'_'+textbox_name[0]]:'')
    const [value2,setVal2] = useState(props.data!=null?props.data[props.qname+'_'+textbox_name[1]]:'')
    const [percentage,setPercentage] = useState(props.value!=null?props.value[props.qname+'_'+textbox_name[2]]:'')
    const [disabled, setDisabled] = useState(true)
    // const textbox_title = props.questions.textbox;
    // const textbox_name = props.questions.textbox_name;


    const onChange = (event,type) =>{
        const value = event.target.value;
        if (type === 0) {
            if (value > 24) {
                setVal1(24);
            } else {
                setVal1(value);
            }
        }
        if (type === 1) {
            if (value > 24) {
                setVal2(24);
            } else {
                setVal2(value);
            }
        }

        props.handler(event)
    }
    useEffect(()=>{
        if (value1!="" && value2!="") {
            let percentage = (value2 / value1) * 100;
            percentage = Math.round(percentage)
            setPercentage(percentage)
            let event  = {'target':{'value':percentage,'name':props.qname+'_'+textbox_name[2]}} // not very good way but it gets the job done
            // let {name,value} = event.target
            props.handler(event)
        }
    },[value1,value2])


    return(
        <>
            <Form.Group as={Col}>
                <Form.Label>{textbox_title[0]}</Form.Label>
                <Form.Control type="number" onChange={(event)=> onChange(event,0)} disable={props.disabled} name={props.qname+'_'+textbox_name[0]} value={value1} disabled={props.disabled}/>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>{textbox_title[1]}</Form.Label>
                <Form.Control type="number" onChange={(event)=> onChange(event,1)}  disable={props.disabled} name={props.qname+'_'+textbox_name[1]} value={value2} disabled={props.disabled}/>
            </Form.Group>
            <Form.Group as={Col}>
                <Form.Label>{textbox_title[2]}</Form.Label>
                <Form.Control type="number" onChange={onChange} name={props.qname+'_'+textbox_name[2]} value={percentage} disabled={true}/>
            </Form.Group>
           </>
    )
}


function getAnswerIndex(array,answer){
    
    for (var i =0; i<array.length;i++){
        
       
            var index = array[i].indexOf(answer);
            if(index> -1){
                return i;
            }
        
        
        
    }
}
function AnswerField_Score(props){
    
    const event_name = props.name.toString()
    let answers = props.answers
    var scoreIndex;
    if(props.data!=null){
        scoreIndex =getAnswerIndex(answers,props.data)
    }
    
    
    const [changed,triggerChange] = useState(props.data!=null?true:false)
    const [previous,setPrevious] = useState(props.data!=null?answers[scoreIndex][1]:0)
    const [value,setVal] = useState(props.data!=null?props.data:answers[0][0])
    const [textValue,setTextValue] = useState('')
    useEffect(()=>{
        if(props.data!=null){
            if(event_name=='p3_3c'){
                setTextValue(props.data_full['p3_3c_minutes_lev_dose'])
            }
            if(event_name =='p3_dyskinesia_impact'){
                setTextValue(props.data_full['p3_dyskinesia_impact_interfere_ratings'])
            }
        }
    },[props.data])
    const handleAnswer =  (e) =>{
       setVal(e.target.value)
       const newScore = parseInt(answers[e.target.selectedIndex][1])
       if (isNaN(newScore)){
            // blank option selected — undo previous score and reset
            if (changed && !isNaN(previous)){
                props.score(-previous)
            }
            setPrevious(0)
            triggerChange(false)
       }
       else if (changed){
            props.score(-previous)
            props.score(newScore)
            setPrevious(newScore)
       }
       else{
            setPrevious(newScore)
            triggerChange(true)
            props.score(newScore)
        }
        props.handler(e)
    }
    const handleText =(event) =>{
        setTextValue(event.target.value)
        props.handler(event)
    }
   
    
        return(
        <>
        <Form.Group as={Col}>
               
                <Form.Control as={"select"} onChange={handleAnswer} name={event_name} value={value} disabled={props.disabled}>
                        
                        {answers.map((answer,index) =>(
                            <option key={index} score={answer[1]}>{answer[0]}</option>))}
                </Form.Control>
        </Form.Group>
        {(event_name == 'p3_3c' && value =='Yes') && 
                           
                            <Form.Group>
                                <Form.Label>Minutes since last levodopa dose</Form.Label>
                                <Form.Control type={'text'} name={'p3_3c_minutes_lev_dose'}value={textValue} onChange={handleText} disabled={props.disabled}/>
                            </Form.Group>
        }
        {(event_name == "p3_dyskinesia_impact" && value =='Yes') && 
        <Form.Group>
                                <Form.Label>Did these movements interfere with your ratings?</Form.Label>
                                <Form.Control as={'select'} name={'p3_dyskinesia_impact_interfere_ratings'}value={textValue} onChange={handleText} disabled={props.disabled}>
                                    <option></option>
                                    <option>Yes</option>
                                    <option>No</option>

                                </Form.Control>
                            </Form.Group>
        }
        {}
        </>
    
        )
    }

// function Part4_textbox(props) {
//     const [value,setVal] = useState("")
//     const name = props.name
//     const handleVal = (event) =>{
//         setVal(event.target.value)
//         props.handler(event)
//     }
//     return(
//         <Form.Group>
//             <Form.Label>{props.title}</Form.Label>
//             <Form.Control type="text" value={value} name={name}/>
//         </Form.Group>
//     )
// }

class Updrs_table extends React.Component {
    constructor(props){
        super(props)
        this.state = {score:0,p3c_disabled:true}
        
    }
   
    render(){
        let questions = this.props.questions
        

        return(
            <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                <thead>
                        <tr>
                            
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                </thead>
                <tbody>
                    {questions.map((question,index)=>{
                        var question_index  ;
                        var letter_prefix = false;
                       if(this.props.part == 'p3') {
                           
                            if(index+1<=3){
                                let abc = ['a','b','c']
                                question_index = String(abc[index])
                                letter_prefix = true;

                            }
                            else{
                                question_index = index -2
                            }
                       }
                       else{
                            question_index = index +1
                       }
                    return (
                        <tr key={index}>
                            {letter_prefix ?<td >{this.props.part.replace(/\D/g,'')}{question_index}.{question.title}</td> : <td>{this.props.part.replace(/\D/g,'')}.{question_index}.{question.title}</td>}
                           <td width={500}> 
                                {("check3" in question )&&<Checkbox_3 key={index} data={this.props.data!=null?this.props.data[question.name]:null} disabled={this.props.disabled} name={question.name} handler={this.props.handler} answers={question.answers} fieldName={this.props.fieldName}/> 
                                }
                                {(question.score_num == null && !("check3" in question))&&<AnswerField_Score data_full={this.props.data} name={question.name} disabled={this.props.disabled} data={this.props.data!=null?this.props.data[question.name]:null}handler={this.props.handler} answers={question.answers} fieldName={this.props.fieldName} score={this.props.scoreFunc}/>}
                                {
                                    
                                    question.score_num!=null&& question.score_num.map((score,i)=>( <AnswerField_Multiple key={i} disabled={this.props.disabled} data={this.props.data!=null?this.props.data[question.name+'_'+score]:null} name={question.name+'_'+(score)} title={score} handler={this.props.handler} answers={question.answers} fieldName={this.props.fieldName} score={this.props.scoreFunc}/>))
                                }
                                {/*{*/}
                                {/*    "textbox" in question && question.textbox.map((q,i)=>(<Text_Box key={i} disabled={this.props.disabled} name={question.name+'_'+(question.textbox_name[i])} title={q} value={this.props.data} handler={this.props.handler} />))*/}
                                {/*}*/}
                               {
                                   "textbox" in question && <Text_box_P4 questions={question} qname={question.name} handler={this.props.handler} data={this.props.data} disabled={this.props.disabled}/>
                               }
                                
                                
                            </td>
                        </tr>
                    )
                    })}
                </tbody>
            </Table>
        )
    }
    
}
Updrs_table.defaultProps = {
    Scoring:false,
    score:null,
    data:null,
    disabled:false
}


export default Updrs_table;